<script>
import { get } from '@rails/request.js';
import { DateTime } from 'luxon';

export default {
  name: 'TimetableMixin',
  data() {
    return {
      slotHeaderIntervalTimes: {
        collapsed: '01:00:00',
        expanded: '00:30:00'
      },
      slotHeaderIntervalIcons: {
        collapse: 'bi-arrows-collapse-vertical',
        expand: 'bi-arrows-expand-vertical'
      }
    }
  },
  methods: {
    timeZone: function() {
      const meta = document.querySelector('meta[name="time-zone"]');
      if (!meta) return DateTime.local().zoneName
      return meta.content;
    },
    getEventByIdAndSource(id, sourceId) {
      return this.$refs.calendar.getApi().getEvents().find(event =>
        event.id == id && event.source.id == sourceId
      );
    },
    toggleSlotHeaderInterval: function(el) {
      const calendarApi = this.$refs.calendar.getApi()
      // Can be clicked on the span-element if the icon within the button or on the button itself
      const icon = el.srcElement.querySelector('span') || el.srcElement
      icon.classList.toggle(this.slotHeaderIntervalIcons.collapse)
      icon.classList.toggle(this.slotHeaderIntervalIcons.expand)

      const newSlotHeaderInterval = calendarApi.getOption('slotHeaderInterval') == this.slotHeaderIntervalTimes.collapsed ? this.slotHeaderIntervalTimes.expanded : this.slotHeaderIntervalTimes.collapsed
      calendarApi.setOption('slotHeaderInterval', newSlotHeaderInterval);
    },
    onClick: async function(eventClickInfo) {
      eventClickInfo.jsEvent.preventDefault();
    },
    refreshShiftsOfVolunteer: async function(volunteerId) {
      const calendarApi = this.$refs.calendar.getApi()
      const response = await get(this.shiftsUrl, { query: {
        "start": calendarApi.view.currentStart.toISOString(),
        "end": calendarApi.view.currentEnd.toISOString(),
        "volunteer_id": volunteerId,
      }})
      if (!response.ok) {
        return
      }

      const shiftEventSource = calendarApi.getEventSourceById("shifts")
      const content = await response.json
      for (const shift of content) {
        this.getEventByIdAndSource(shift.id, 'shifts')?.remove()
        calendarApi.addEvent(shift, shiftEventSource)
      }
    },
  }
}
</script>
